import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  btnBlue: {
    color: '#FFFFFF',
    fontWeight: 'bold',
    backgroundColor: '#4386E5',
    textTransform: 'uppercase',
  },
}));
